import { IconType } from 'react-icons';
import { AiTwotoneGold } from 'react-icons/ai';
import { IoTrashBin } from 'react-icons/io5';
import { MdPushPin, MdScience } from 'react-icons/md';
import { VscActivateBreakpoints } from 'react-icons/vsc';

import { FlowDetailSuppliers, FlowsGroup, FlowsGroupNoWaste } from 'hooks/data/datasets/V4/flows/types';

export const groupToIcon: { [key in FlowsGroup]: IconType } = {
  resource: MdPushPin,
  waste: IoTrashBin,
  valuable: AiTwotoneGold,
  emission: MdScience,
  'by-product': VscActivateBreakpoints,
  'reference flow': MdPushPin,
};

export const groupToIconBackground: { [key in FlowsGroup]: string } = {
  resource: 'red',
  waste: 'yellow',
  valuable: 'blue',
  emission: 'orange',
  'by-product': 'pink',
  'reference flow': 'red',
};

export const groupToTooltipLabel: { [key in FlowsGroupNoWaste]: string } = {
  resource:
    'This flow represents a natural resource or environmental input consumed by the process directly from nature. Ecosphere inputs include raw materials, land use, water resources, and other natural assets extracted from the environment.',
  valuable:
    'This flow represents a good or service consumed by the process from other human-made systems or industrial processes. Technosphere inputs include materials, energy, equipment, and services that are produced and supplied by the broader economic system.',
  emission:
    'This flow represents a substance released by the process directly into the ecosphere. Emissions are discharged to air, water, or soil.',
  'by-product': 'Origin/destination of elementary exchanges: air, soil, water, etc.',
  'reference flow':
    'This flow represents the main output that drives the process (also known as the determining flow), defining why the process exists and operates. Functional flows can be either goods or services and serve as the reference unit for all environmental impact calculations.',
};

export const groupToTooltipTitle: { [key in FlowsGroup]: string } = {
  resource: 'Resource',
  waste: 'Waste',
  valuable: 'Technosphere input',
  emission: 'Emission',
  'by-product': 'Byproduct',
  'reference flow': 'Functional Flow',
};

export const supplierTypeToDisplayName: { [key in FlowDetailSuppliers['type']]: string } = {
  'Transforming activity': 'Transforming Process',
  'Import mix': 'Import Mix',
  'Domestic supply mix': 'Domestic Supply Mix',
  'Consumption mix': 'Consumption Mix',
  'Global supply mix': 'Global Supply Mix',
};

export const supplierTypeToIconBackground: { [key in FlowDetailSuppliers['type']]: string } = {
  'Transforming activity': 'green',
  'Import mix': 'teal',
  'Domestic supply mix': 'cyan',
  'Consumption mix': 'blue',
  'Global supply mix': 'purple',
};

export const supplierTypeToTooltipLabel: { [key in FlowDetailSuppliers['type']]: string } = {
  'Transforming activity':
    'A human process that transforms inputs into outputs that are different from the inputs. This is the most common type of process in the ecoinvent database, e.g. a hard coal mine that transforms hard coal in ground to the marketable product hard coal, or an automobile plant that turns metals, plastics and energy into cars.',
  'Import mix':
    'The aggregated flow of a specific product into a receiving geographic region, representing the combined imports from all supplying geographic regions according to their respective shares. The Import mix excludes re-exports.',
  'Domestic supply mix':
    'Combination of different producers using different technologies to produce the same product within the same geographic region. The DSM excludes production allocated to exports.',
  'Consumption mix':
    'The weighted aggregation of the Domestic Supply and Import Mix. It answers the question “what is the proportion of the flow being produced by the domestic supply mix and import mix in this geographic region?”',
  'Global supply mix':
    'The global supply mix represents the aggregated flow of a specific product across all geographic regions, combining domestic supply mixes and import mixes from all regions. It provides a comprehensive view of the global production and distribution of the product.',
};

export const DIRECTION_KEYWORDS: Record<string, 'inputs' | 'outputs'> = {
  input: 'inputs',
  output: 'outputs',
};

export const GROUP_KEYWORDS: Record<string, FlowsGroup> = {
  waste: 'waste',
  valuable: 'valuable',
  reference: 'reference flow',
};
